import jQuery from 'jquery';

import 'regenerator-runtime/runtime';

const $ = jQuery;

require("./modules/polyfill");

require("./modules/useragent");

require("./modules/loading");

require("./modules/site");

require("./modules/menu");

require("./modules/slider");

require("./modules/lightbox");
